import { useState, type FC, type Ref } from 'react';

import { InfoOutline } from '@/core/tamagoshi/icons/InfoOutline';
import {
  Popover,
  PopoverLayover,
  PopoverTrigger,
} from '@/core/tamagoshi/Popover/Popover';
import { useCarbonScore } from '@/domains/sustainability/carbonScore/hooks/useCarbonScore';
import { isCarbonScoreAttribute } from '@/domains/sustainability/carbonScore/utils/carbonScoreAttribute';

import { usedForCarbonScoreCalculationText } from './translations';

import styles from './CarbonScoreAttribute.module.scss';

interface Props {
  attributeId?: number;
}
export const CarbonScoreAttribute: FC<Props> = ({ attributeId }) => {
  const carbonScore = useCarbonScore();

  const displayCarbonScoreAttributeText =
    attributeId && carbonScore && isCarbonScoreAttribute(attributeId);

  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  const toggleTooltip = (value: boolean) => () => {
    setIsTooltipVisible(value);
  };

  return displayCarbonScoreAttributeText ? (
    <Popover
      isVisible={isTooltipVisible}
      onClose={toggleTooltip(false)}
      position="right"
    >
      <PopoverTrigger>
        {(event: { ref: Ref<HTMLDivElement> }) => (
          <div
            className={styles.icon}
            onBlur={toggleTooltip(false)}
            onClick={toggleTooltip(true)}
            onFocus={toggleTooltip(true)}
            onKeyUp={toggleTooltip(true)}
            onMouseLeave={toggleTooltip(false)}
            onMouseOver={toggleTooltip(true)}
            ref={event.ref}
            role="button"
            tabIndex={0}
            data-testid="icon-info"
          >
            <InfoOutline className={styles.infoIcon} height={16} width={16} />
          </div>
        )}
      </PopoverTrigger>
      <PopoverLayover>{usedForCarbonScoreCalculationText}</PopoverLayover>
    </Popover>
  ) : null;
};
